import React from 'react';
import {
  Checkbox,
  Form,
  FormFieldProps,
  Input,
  InputProps,
} from 'semantic-ui/semantic-ui-imports';

interface Props {
  name: string;
  label: string;
  onChange: (name: string, val: string) => void;
  unit?: string | null;
  updateName?: string | null;
  inputProps?: InputProps;
  formFieldProps?: FormFieldProps;
  defaultValue?: string | number | null;
  value?: string | number;
  maxInputWidth?: number;
  disableInputName?: string;
  disabledValue?: boolean;
  onDisabledChange?: (name: string, val: boolean) => void;
}

const FilterInput = ({
  name,
  label,
  defaultValue,
  onChange,
  unit,
  updateName,
  inputProps,
  formFieldProps,
  value,
  disableInputName,
  disabledValue,
  onDisabledChange,
}: Props) => (
  <Form.Field {...formFieldProps}>
    {disableInputName && (
      <Checkbox
        name={disableInputName}
        checked={disabledValue}
        style={{ fontSize: 'inherit', fontWeight: 'bold' }}
        onChange={(ev: any, data: any) =>
          onDisabledChange && onDisabledChange(disableInputName, data.checked)
        }
        label={` ${label}`}
      />
    )}
    {!disableInputName && <label htmlFor={name}>{label}</label>}
    <Input
      name={name}
      label={unit ? { basic: true, content: unit } : false}
      labelPosition={unit ? 'right' : undefined}
      defaultValue={defaultValue}
      value={value}
      onChange={(e: { target: { value: string } }) => {
        onChange(updateName || name, e.target.value);
      }}
      disabled={!disabledValue}
      {...inputProps}
    />
  </Form.Field>
);

FilterInput.defaultProps = {
  unit: null,
  updateName: null,
  inputProps: {},
  formFieldProps: {},
};

export default FilterInput;
